import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AppBarDefault, AppBarDividerMaxHeight, AppBarMercury, AppBarMinHeight, AppBarMinHeightWide, AppBarWide, } from './Constants';
/**
 * Represents the styles for the AppBar, selection bar and tile container
 */
export var useAppBarStyles = makeStyles({
    appBar: {
        height: '100%',
        width: AppBarDefault,
    },
    twoColumnViewBackground: {
        backgroundColor: tokens.colorNeutralBackground4,
    },
    threeColumnViewBackground: {
        backgroundColor: tokens.colorNeutralBackground5,
    },
    wideAppBar: __assign({ width: AppBarWide }, shorthands.padding(0)),
    mercuryDesignAppBar: __assign(__assign({ width: AppBarMercury }, shorthands.padding(0, '10px')), { paddingTop: '10px' }),
    tileContainer: {
        minHeight: AppBarMinHeight,
        overflowX: 'visible',
    },
    // This is being used for AI hub.
    tileContainerCenterAligned: {
        flexGrow: 100,
        justifyContent: 'center',
        minHeight: AppBarMinHeight,
        overflowX: 'visible',
    },
    tileContainerWide: {
        minHeight: AppBarMinHeightWide,
    },
    // This is being used for AI hub.
    tileContainerWideCenterAligned: {
        flexGrow: 100,
        justifyContent: 'center',
        minHeight: AppBarMinHeightWide,
    },
    animated: {
        transitionProperty: 'all',
        transitionDuration: '.26s',
        transitionTimingFunction: 'cubic-bezier(.78,0,.22,1)',
    },
    divider: __assign(__assign({}, shorthands.margin('2px', '0px', '2px', '0px')), { maxHeight: AppBarDividerMaxHeight, color: tokens.colorNeutralStroke2 }),
    transparent: {
        backgroundColor: tokens.colorTransparentBackground,
    },
});
//# sourceMappingURL=AppBar.styles.js.map